export default "__VITE_ASSET__DArFTo9O__"